
export class CaptchaProtection {
  constructor (cookieHandler, config, headers = null) {
    this.cookieHandler = cookieHandler
    this.headers = headers || {}

    if (!config) {
      throw new Error('config')
    }
    this.config = config || {
      CAPTHCA_REQUEST_VALIDATION: false,
    }
  }

  static get CookieName () {
    return 'cpp'
  }

  requestValidationPass () {
    // console.log({ bot: this.isKnownBot() })
    if (!this.config?.CAPTHCA_REQUEST_VALIDATION) {
      return true
    }
    return this._cookieValidationPass() || this._uuidCookieExist() || this.isKnownBot()
  }

  requestValidationFail () {
    return !this.requestValidationPass()
  }

  setCookie () {
    const options = {
      // httpOnly: true,
      sameSite: 'lax',
      path: '/',
      domain: process.env.APP_HOST ? `.${process.env.APP_HOST}` : '.setsushi.ru',
      secure: process.env.NODE_ENV === 'production',
      maxAge: 30 * 24 * 60 * 60, // seconds
    }
    this.cookieHandler.set(CaptchaProtection.CookieName, '1', options)
  }

  _cookieValidationPass () {
    const cookieValue = this.cookieHandler.get(CaptchaProtection.CookieName)
    return String(cookieValue) === '1'
  }

  _uuidCookieExist () {
    return !!this.cookieHandler.get('uuid')
  }

  // --- добавлено: проверка известных поисковых ботов ---
  isKnownBot () {
    const ua = (this.headers['user-agent'] || '').toLowerCase()
    // console.log({ userAgent: ua })

    const knownBots = [
      'googlebot',
      'yandexbot',
      'bingbot',
      'duckduckbot',
      'baiduspider',
      'sogou',
      'exabot',
      'facebot',
      'ia_archiver',
      'yandex.com/bots',
      'ahrefsbot',
      'uptimerobot',
    ]

    return knownBots.some(bot => ua.includes(bot))
  }
}
